/**
 * Waiting for the reader's first paint, then for the browser to be idle.
 *
 * Used by the home globe: the directory, the hero and the atlas art are painted
 * from the document's own payload, and MapLibre's ESM is the largest single
 * download on the page, so the map waits for that paint instead of racing it.
 */
export function afterFirstPaint(): Promise<void> {
  return new Promise<void>((resolve) => {
    // Two frames guarantee a paint has been committed (`requestIdleCallback` can run
    // between frames, before anything is visible).
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // The idle callback then says the main thread is free; its `timeout` keeps
        // the map from waiting forever under a busy host. A browser without it —
        // Safari before 15.4 — gets a short timer.
        if (typeof requestIdleCallback === "function") {
          requestIdleCallback(() => resolve(), { timeout: 2000 });
          return;
        }
        setTimeout(resolve, 200);
      });
    });
  });
}
